// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__3EiVu"};